import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  tipContainer: {
    paddingRight: 10,
    borderWidth: 2,
    borderRadius: 5,
    marginTop: 20,
  },
  container: {justifyContent: 'flex-start'},
  renderDetailsValueText: {
    textAlign: 'left',
  },
  imageStyle: {
    height: 95,
    width: 105,
    marginRight: 10,
    paddingRight: 10,
  },
});
